import {
  ADD_CONTEXT_LABEL_STEPS,
  ADD_CONTEXT_STEPS,
  COLLECTION_CONTEXT_TYPES,
  contextTypeSupportsAddLabels,
} from './contextTypes';

export const COLLECTION_CONNECTOR_TYPES = Object.freeze({
  Swapcard: 'swapcard',
});

export const CONNECTOR_CONNECTION_STATUS = Object.freeze({
  Idle: 'idle',
  Testing: 'testing',
  Connected: 'connected',
  Failed: 'failed',
});

export const CONNECTOR_PLATFORM_OPTIONS = Object.freeze([
  {
    value: COLLECTION_CONNECTOR_TYPES.Swapcard,
    label: 'Swapcard',
  },
]);

export const CONNECTOR_PLATFORM_LABELS = Object.freeze({
  [COLLECTION_CONNECTOR_TYPES.Swapcard]: 'Swapcard',
});

export const getDefaultConnectorDraft = () => ({
  connectorType: null,
  apiKey: '',
  eventId: '',
  connectionStatus: CONNECTOR_CONNECTION_STATUS.Idle,
  connectionError: null,
});

export const ADD_CONNECTOR_STEPS = Object.freeze([
  { title: 'Select type' },
  { title: 'Configure Platform' },
  { title: 'Review' },
]);

export const getAddContextSteps = selectedContextType => {
  if (selectedContextType === COLLECTION_CONTEXT_TYPES.Connector) {
    return ADD_CONNECTOR_STEPS;
  }
  if (contextTypeSupportsAddLabels(selectedContextType)) {
    return ADD_CONTEXT_LABEL_STEPS;
  }
  return ADD_CONTEXT_STEPS;
};

export const getConnectorPlatformLabel = connectorType =>
  CONNECTOR_PLATFORM_LABELS[connectorType] || connectorType || 'Connector';
